export default "__VITE_ASSET__CuSbCZB9__"